import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';

import RMFSSN5 from './components/RMFSSN5/RMFSSN5';
import RMFSSN9 from './components/RMFSSN9/RMFSSN9';

const RMFSSN: React.FC = () => {
  const isSSN9Enabled = useFeature(FeatureFlag.SwcSSN9);

  return isSSN9Enabled ? <RMFSSN9 showLockIcon page={RMFSSN} /> : <RMFSSN5 page={RMFSSN} />;
};

RMFSSN.displayName = 'RMFSSN';

export default RMFSSN;
